import { DependencyList, useEffect, useRef } from 'react';

export const useEffectChange = (
	callback: (prevDep: DependencyList, dep: DependencyList) => void,
	deps: DependencyList = [],
	skipMount: boolean = true,
) => {
	const isFirstLoad = useRef(true);
	const previousDeps = useRef<DependencyList>([]);

	useEffect(() => {
		if (!isFirstLoad.current || !skipMount) {
			const cleanupFn = callback([...previousDeps.current], [...deps]);
			previousDeps.current = deps;
			return cleanupFn;
		} else {
			isFirstLoad.current = false;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
};
